import apiClient from './api';
import { User, NewUser, UpdateUser } from '../types/user';

const getUsers = async (): Promise<User[]> => {
  const response = await apiClient.get<User[]>('/users/');
  return response.data;
};

const createUser = async (userData: NewUser): Promise<User> => {
  const response = await apiClient.post<User>('/users/', userData);
  return response.data;
};

const updateUser = async (id: number, userData: UpdateUser): Promise<User> => {
  const response = await apiClient.patch<User>(`/users/${id}/`, userData);
  return response.data;
};

const getUser = async (id: number): Promise<User> => {
    const response = await apiClient.get<User>(`/users/${id}/`);
    return response.data;
};

export const userService = {
  getUsers,
  createUser,
  updateUser,
  getUser,
};